module.exports = __webpack_public_path__ + "static/media/gro_flo_sit_spe_met.b8ed6a5e.png";